<div class="container col-xxl-8 px-4 py-5 landing-content" >
    <div class="row align-items-center g-5 py-5">
  
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Contact Us</h1>
        <div class="row align-items-center g-5 py-5">

            <h2 class="display-5 lh-1 mb-3">Mailing Address:</h2>
            <p class="light-font-container">
                Canada GPS<br>
                GeoAstra Software Division<br>
                9225 Leslie Street<br>
                Suite 201<br>
                Richmond Hill, ON, L4B 3H6<br>
                Canada
            </p>

            <h2 class="display-5 lh-1 mb-3">Email:</h2>
            <p class="light-font-container">
                <a href="mailto:info@geoastra.com">info&#64;geoastra.com</a>
            </p>

            <h2 class="display-5 lh-1 mb-3">Phone Number:</h2>
            <p class="light-font-container">
                +1 647-723-3072
            </p>

            <h2 class="display-5 lh-1 mb-3">Hours of Operation:</h2>
            <p class="light-font-container">
                Mon - Fri 9am - 5pm EST, Sat, Sun &amp; Public Holidays Closed<br>
                Ntrip Caster Operation 24x7x365
            </p>


      </div>

    </div>
  </div>

